<form #searchForm="ngForm" autocomplete="off">
  <div class="modal-body">
    <p>Search by EIN, EdSH ID, name, or social security number. Results update as you type.</p>
    <div class="row g-3">
      <div class="col-md-6">
        <label for="workforce-person-ein" class="form-label">Educator ID / EIN</label>
        <input
          id="workforce-person-ein"
          name="ein"
          class="form-control"
          inputmode="numeric"
          #einControl="ngModel"
          [ngModel]="ein"
          (ngModelChange)="einChanged.emit({ value: $event, form: searchForm })"
          ngbAutofocus
        />
        <div validationErrors [for]="einControl.control" [errorEmitter]="errorEmitter"></div>
      </div>
      <div class="col-md-6">
        <label for="workforce-search-edShId" class="form-label">EdSH ID</label>
        <input
          id="workforce-search-edShId"
          name="edShId"
          type="text"
          inputmode="numeric"
          mask="0000-0000-0000-0000"
          [validation]="false"
          class="form-control"
          #edShId="ngModel"
          [ngModel]="fields.edShId"
          (ngModelChange)="fieldsChanged.emit({ field: 'edShId', value: $event, form: searchForm })"
        />
        <div validationErrors [for]="edShId.control" [errorEmitter]="errorEmitter"></div>
      </div>
    </div>
    <div class="row g-3 mt-1">
      <div class="col-md-6">
        <label for="workforce-search-firstName" class="form-label">First Name</label>
        <input
          id="workforce-search-firstName"
          name="firstName"
          type="text"
          class="form-control"
          #firstName="ngModel"
          [ngModel]="fields.firstName"
          (ngModelChange)="fieldsChanged.emit({ field: 'firstName', value: $event, form: searchForm })"
        />
        <div validationErrors [for]="firstName.control" [errorEmitter]="errorEmitter"></div>
      </div>
      <div class="col-md-6">
        <label for="workforce-search-lastName" class="form-label">Last Name</label>
        <input
          id="workforce-search-lastName"
          name="lastName"
          type="text"
          class="form-control"
          #lastName="ngModel"
          [ngModel]="fields.lastName"
          (ngModelChange)="fieldsChanged.emit({ field: 'lastName', value: $event, form: searchForm })"
        />
        <div validationErrors [for]="lastName.control" [errorEmitter]="errorEmitter"></div>
      </div>
      <div class="col-md-12">
        <label for="workforce-search-ssn" class="form-label">SSN (full number or last 4 digits)</label>
        <input
          id="workforce-search-ssn"
          name="ssn"
          type="text"
          inputmode="numeric"
          mask="0000||000-00-0000"
          [validation]="false"
          obscure
          class="form-control"
          #ssn="ngModel"
          [ngModel]="fields.ssn"
          (ngModelChange)="fieldsChanged.emit({ field: 'ssn', value: $event, form: searchForm })"
        />
        <div validationErrors [for]="ssn.control" [errorEmitter]="errorEmitter"></div>
      </div>
    </div>
    <p class="small text-muted mt-2">
      For name searches, enter at least 2 letters of the first name or 3 of the last name.
    </p>
    <div formLevelValidationErrors [for]="searchForm" [errorEmitter]="errorEmitter"></div>
    @if (isSearching) {
      <p class="mt-3 mb-0" role="status">Searching the state directory…</p>
    }
    @if (error) {
      <p class="alert alert-danger mt-3 mb-0" role="alert">{{ error }}</p>
    }
    @if (searchedEin !== null && matches.length === 0) {
      <div class="alert alert-info mt-3 mb-0" role="status">
        <strong>No person found with these search details.</strong>
        @if (canCreatePerson) {
          <p class="mb-2">If this person has no existing state record, create one to continue.</p>
          <button type="button" class="btn btn-primary" (click)="createPerson.emit()">Create Person</button>
        } @else {
          <p class="mb-0">
            Your account does not have permission to create a person. Contact an authorized person-record creator.
          </p>
        }
      </div>
    }
    @if (hasMoreMatches) {
      <p class="alert alert-info mt-3" role="status">
        Showing the first 50 matches. Add more details to narrow your search.
      </p>
    }
    @if (matches.length > 0) {
      <div class="search-results mt-3 px-2" role="region" aria-label="Search results" tabindex="0">
        <div class="row g-3">
          @for (person of matches; track person.personId) {
            <div class="col-md-6">
              <div class="border rounded p-3 h-100">
                <div class="small text-muted">State person record</div>
                <strong>{{ person.firstName }} {{ person.middleName }} {{ person.lastName }}</strong>
                <div>EIN {{ person.ein }}</div>
                <div>EdSH ID {{ person.edShId | guidFormat }}</div>
                @if (person.isAlreadyActiveInLea) {
                  <div class="mt-2" role="status">
                    <span class="badge badge-warning">Already on this roster</span>
                    <p class="mb-0 mt-2">
                      This person already has active employment on this roster. Review their existing staff record.
                    </p>
                  </div>
                } @else if (selectedPerson?.personId === person.personId) {
                  <div class="mt-2" role="status">
                    <span class="badge badge-success">Selected person</span>
                    <p class="mb-0 mt-2">Continue to enter employment details.</p>
                  </div>
                } @else {
                  <button type="button" class="btn btn-outline-primary mt-2" (click)="personSelected.emit(person)">
                    Select Person
                  </button>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (searchedEin !== null && matches.length > 0 && canCreatePerson) {
      <div class="mt-3">
        <p>Can't find the person you're looking for?</p>
        <button type="button" class="btn btn-outline-primary" (click)="createPerson.emit()">Create Person</button>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancelled.emit()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="!selectedPerson" (click)="continueToEmployment.emit()">
      Continue to Employment
    </button>
  </div>
</form>
